<template>
    <div class="paddingBox">
        <div class="d-flex align-items-center justify-content-between mb-20">
            <h2 class="mb-0">Registrácia kolektívu</h2>
            <p class="mb-0">Prosíme, vyplňte všetky polia.</p>
        </div>
        <div class="rounded-box --whiteBg p-50">
            <validation-observer v-slot="{ handleSubmit, errors }">
            <form @submit.prevent="handleSubmit(submitKolektiv)" novalidate>
                <div class="form-row">
                    <div class="col-12 col-md-12">
                        <validation-provider name="Názov kolektívu" v-slot="{ errors }">
                            <label for="nazov-kolektivu">Názov kolektívu</label>
                            <input type="text" class="form-control" name="nazov-kolektivu" id="nazov-kolektivu" v-model="form.pouzivatel_name" :class="{'is-error' : errors.length }" required>
                            <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <validation-provider name="Kontaktný e-mail" v-slot="{ errors }">
                            <label for="kontaktny-email">Kontaktný e-mail</label>
                            <input type="email" class="form-control" name="kontaktny-email" id="kontaktny-email" v-model="form.pouzivatel_email" :class="{'is-error' : errors.length }" required>
                            <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>
                    <div class="col-12 col-md-6">
                        <validation-provider name="Heslo" v-slot="{ errors }">
                            <label for="heslo">Vytvorte si heslo</label>
                            <input type="password" class="form-control" name="heslo" id="heslo" v-model="form.pouzivatel_password" :class="{'is-error' : errors.length }" required>
                            <span class="text-danger">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-start">
                            <label class="w-auto mr-3 mb-0">Typ kolektívu</label>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadioInline1" name="customRadioInline" class="custom-control-input" v-model="typ_kolektivu" value="zs">
                                <label class="custom-control-label" for="customRadioInline1">Škola</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="customRadioInline2" name="customRadioInline" class="custom-control-input" v-model="typ_kolektivu" value="ms" >
                                <label class="custom-control-label" for="customRadioInline2">Škôlka</label>
                            </div>
                        </div>
                    </div>
                </div>

<!--                <div class="form-row">-->
<!--                    <div class="col-12 col-md-6">-->
<!--                        <label for="kraj">Kraj</label>-->
<!--                        <v-select id="kraj" label="name" :options="kraje" v-model="form.pouzivatel_kraj" :reduce="kraj => kraj.name" :clearable="false" @input="clearSelected('kraj')" />-->
<!--                    </div>-->

<!--                    <div class="col-12 col-md-6">-->
<!--                        <label for="okres">Okres</label>-->
<!--                        <v-select id="okres" label="name" :options="filteredOkresy" v-model="form.pouzivatel_okres" :reduce="okres => okres.name" :clearable="false" />-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="form-row">-->
<!--                    <div class="col-12 col-md-12">-->
<!--                        <label for="mesto-obec">Mesto / Obec</label>-->
<!--                        <v-select id="mesto-obec" label="fullname" :options="filteredObce" v-model="form.pouzivatel_obec" :reduce="obec => obec.fullname" :clearable="false" />-->
<!--                    </div>-->
<!--                </div>-->

                <div class="form-row">

                    <div class="col-12 col-md-9">
                        <template v-if="typ_kolektivu === 'zs'">
                            <validation-provider rules="required" name="Škola" v-slot="{ errors }" key="skola">
                                <label for="skola">Škola</label>
                                <v-select
                                    :filter="filterSkoly"
                                    id="skola"
                                    label="cely_nazov"
                                    :options="skoly"
                                    v-model="form.pouzivatel_skola"
                                    :clearable="false"
                                    placeholder="Začnite písať pre vyhľadanie školy zo zoznamu"
                                    :class="{'is-error' : errors.length }"
                                >
                                    <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            Nenašla sa žiadna škola <em>{{ search }}</em>.
                                        </template>
                                    </template>
                                </v-select>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>
                        <template v-if="typ_kolektivu === 'ms'">
                            <validation-provider rules="required" name="Škôlka" v-slot="{ errors }" key="skolka">
                                <label for="skolka">Škôlka</label>
                                <v-select
                                    :filter="filterSkoly"
                                    id="skolka"
                                    label="cely_nazov"
                                    :options="skolky"
                                    v-model="form.pouzivatel_skola"
                                    :clearable="false"
                                    placeholder="Začnite písať pre vyhľadanie škôlky zo zoznamu"
                                    :class="{'is-error' : errors.length }"
                                >
                                    <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            Nenašla sa žiadna škôlka <em>{{ search }}</em>.
                                        </template>
                                    </template>
                                </v-select>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>
                    </div>

                    <div v-if="typ_kolektivu === 'zs'" class="col-12 col-md-3">
                        <label for="rocnik">Ročník</label>
                        <select name="rocnik" class="custom-select" id="rocnik" v-model="form.pouzivatel_rocnik">
                            <option :value="1">1. ročník</option>
                            <option :value="2">2. ročník</option>
                            <option :value="3">3. ročník</option>
                            <option :value="4">4. ročník</option>
                        </select>
                    </div>

                </div>

                <div class="form-row">
                    <div class="col-md-12">
                        <div class="separator"></div>
                    </div>
                </div>

                <div class="form-row mb-0">
                    <div class="col-12 col-md-12 text-right">
                        <button class="btn --primary" type="submit">pokračovať na ďalší krok</button>
                    </div>
                </div>
            </form>
            </validation-observer>

        </div>
    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    // import okresy from '@/services/okresy.json'
    // import kraje from '@/services/kraje.json'
    // import obce from '@/services/obce.json'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    import Fuse from "fuse.js";

    export default {
        components: {
            vSelect
        },
        props: {
            form: {
                type: Object,
                required: true
            }
        },
        computed: {
            // filteredOkresy() {
            //     if ( this.form.pouzivatel_kraj ) {
            //         let selectedKraj = this.kraje.find( kraj => kraj.name === this.form.pouzivatel_kraj )
            //         if ( selectedKraj ) {
            //             return this.okresy.filter( okres => okres.region_id === selectedKraj.id )
            //         }
            //     }
            //
            //     return this.okresy
            // },
            // filteredObce() {
            //     if ( this.form.pouzivatel_okres ) {
            //         let selectedOkres = this.okresy.find( okres => okres.name === this.form.pouzivatel_okres )
            //         if ( selectedOkres ) {
            //             return this.obce.filter( obec => obec.district_id === selectedOkres.id )
            //         }
            //     }
            //
            //     if ( this.form.pouzivatel_kraj ) {
            //         let selectedKraj = this.kraje.find( kraj => kraj.name === this.form.pouzivatel_kraj )
            //         if ( selectedKraj ) {
            //             return this.obce.filter( obec => obec.region_id === selectedKraj.id )
            //         }
            //     }
            //
            //     return this.obce
            // },
            // filteredSkoly() {
            //     return this.filteredObce
            // }
        },
        data() {
            return {
                // okresy: okresy,
                // kraje: kraje,
                // obce: obce,
                skoly: [],
                skolky: [],
                typ_kolektivu: 'zs',
            }
        },
        mounted() {
            this.getZakladneSkoly()
            this.getMaterskeSkoly()
        },
        methods: {
            async getZakladneSkoly() {
                let { data } = await EventService.getZoznamZakladnychSkol()
                this.skoly = data.data
            },
            async getMaterskeSkoly() {
                let { data } = await EventService.getZoznamMaterskychSkol()
                this.skolky = data.data
            },

            filterSkoly(options, search) {
                const fuse = new Fuse(options, {
                    keys: ["cely_nazov"],
                    minMatchCharLength: 3,
                    shouldSort: true
                });
                return search.length
                    ? fuse.search(search).map(({ item }) => item)
                    : fuse.list;
            },

            submitKolektiv() {
                if ( this.typ_kolektivu === 'ms' ) {
                    this.form.pouzivatel_rocnik = 0
                }

                this.$emit('updateStep', 'zoznam' )
            },

            // clearSelected(type) {
            //     // TODO add all options
            //     switch (type) {
            //         case 'kraj':
            //             this.form.pouzivatel_okres = ''
            //             break;
            //         default:
            //             break;
            //     }
            // },
        }
    }
</script>
